import { FAILURE, REQUEST, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_ADMIN_EVENT_LIST = createRequestTypes('GET_ADMIN_EVENT_LIST');
export const getAdminEventList = {
  request: search => action(GET_ADMIN_EVENT_LIST[REQUEST], search),
  success: data => action(GET_ADMIN_EVENT_LIST[SUCCESS], { data }),
  failure: error => action(GET_ADMIN_EVENT_LIST[FAILURE], { error }),
};
